if (!customElements.get("size-converter")) {
  class SizeConverter extends HTMLElement {
    connectedCallback() {
      this._button = this.querySelector(".size-toggle__button");
      if (this._button) {
        this._handleClick ??= (event) => {
          event.preventDefault();
          event.stopPropagation();
          this._onToggle();
        };
        this._button.addEventListener("click", this._handleClick);
      }
      // Restore from localStorage
      const savedSize = localStorage.getItem("active-size");
      if (savedSize && savedSize === this.dataset.alternateSize) {
        this._onToggle(true); // force switch to alternate size
      }
    }
    
    disconnectedCallback() {
      if (this._button && this._handleClick) {
        this._button.removeEventListener("click", this._handleClick);
      }
    }
    
    _onToggle(force = false) {
      const optionSelector = this.closest(".option-selector, details.filter");
      if (!optionSelector) return;
      
      const defaultSize = this.dataset.defaultSize;
      const alternateSize = this.dataset.alternateSize;
      const defaultSizeElements = optionSelector.querySelectorAll(`[data-size="${defaultSize}"]`);
      const alternateSizeElements = optionSelector.querySelectorAll(`[data-size="${alternateSize}"]`);
      
      // Current button state
      let isActive = this._button.getAttribute("aria-pressed") === "true";
      
      // If restoring from storage and not already active → toggle once
      if (force && !isActive) {
        isActive = false;
      }
      
      // Toggle state
      this._button.setAttribute("aria-pressed", String(!isActive));
      
      if (!isActive) {
        // Show alternate (US)
        defaultSizeElements.forEach(el => el.classList.add("hidden"));
        alternateSizeElements.forEach(el => el.classList.remove("hidden"));
        localStorage.setItem("active-size", alternateSize);
        
        // Dispatch event for cart to update
        this._dispatchSizeChangeEvent(alternateSize);
      } else {
        // Show default (UK)
        defaultSizeElements.forEach(el => el.classList.remove("hidden"));
        alternateSizeElements.forEach(el => el.classList.add("hidden"));
        localStorage.setItem("active-size", defaultSize);
        
        // Dispatch event for cart to update
        this._dispatchSizeChangeEvent(defaultSize);
      }
    }
    
    _dispatchSizeChangeEvent(newSize) {
      // Dispatch custom event that cart can listen to
      const event = new CustomEvent('size-toggle-changed', {
        detail: { activeSize: newSize },
        bubbles: true
      });
      document.dispatchEvent(event);
      
      // Also update cart immediately if it's open
      this._updateCartSizeDisplay(newSize);
    }
    
    _updateCartSizeDisplay(activeSize) {
      const sizeDisplays = document.querySelectorAll('.cart-size-display');
      
      sizeDisplays.forEach(display => {
        const ukValue = display.querySelector('.size-uk-value');
        const usValue = display.querySelector('.size-us-value');
        
        if (activeSize === 'US') {
          ukValue?.classList.add('hidden');
          usValue?.classList.remove('hidden');
        } else {
          ukValue?.classList.remove('hidden');
          usValue?.classList.add('hidden');
        }
      });
    }
  }
  
  customElements.define("size-converter", SizeConverter);
}